// extracted by mini-css-extract-plugin
export var container = "personalizer-module--container--Yws-p";
export var containerBillPage = "personalizer-module--container-bill-page--lXNa5";
export var dataSource = "personalizer-module--data-source--mJ8MD";
export var subhed = "personalizer-module--subhed--UnlcP";
export var title = "personalizer-module--title--bI0r1";